import { SET_CONFIG } from '../actionTypes'

export const setConfig = (payload: any) => (dispatch: any) => {
  dispatch({
    type: SET_CONFIG,
    payload,
  })
}
